export default __webpack_public_path__ + "static/media/featured_area_brampton.11611603.webp";